import { Controller } from "@hotwired/stimulus";
import Tribute from "tributejs";

export default class extends Controller {
  static targets = ["input", "picks"];
  static values = { url: String };

  connect() {
    this.selectedPicks = this.readInitialPicks();
    this.tribute = new Tribute({
      values: (text, cb) => this.fetchUsers(text, cb),
      selectTemplate: (item) => `@${item.original.name}`,
      menuItemTemplate: (item) =>
        `<span>${this.escapeHtml(item.original.name)}</span> <small>${this.escapeHtml(item.original.email)}</small>`,
      noMatchTemplate: () => "<li>No matches</li>",
      lookup: "name",
      fillAttr: "name",
      requireLeadingSpace: true,
    });

    this.tribute.attach(this.inputTarget);
    this.inputTarget.addEventListener(
      "tribute-replaced",
      this.onTributeReplaced,
    );
  }

  disconnect() {
    this.inputTarget.removeEventListener(
      "tribute-replaced",
      this.onTributeReplaced,
    );
    if (this.tribute) {
      this.tribute.detach(this.inputTarget);
    }
  }

  escapeHtml(value) {
    return String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  readInitialPicks() {
    if (!this.hasPicksTarget) return [];
    try {
      const raw = this.picksTarget.value;
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .filter((p) => p && p.hashid && p.name)
        .map((p) => ({ hashid: String(p.hashid), name: String(p.name) }));
    } catch {
      return [];
    }
  }

  fetchUsers(text, cb) {
    const url = `${this.urlValue}?q=${encodeURIComponent(text)}`;
    fetch(url, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then((response) => response.json())
      .then((users) => cb(users))
      .catch(() => cb([]));
  }

  onTributeReplaced = (event) => {
    const user = event.detail.item.original;
    if (!user || !user.hashid || !user.name) return;
    this.selectedPicks.push({
      hashid: String(user.hashid),
      name: String(user.name),
    });
    this.writePicks();
  };

  writePicks() {
    if (!this.hasPicksTarget) return;
    this.picksTarget.value = JSON.stringify(this.selectedPicks);
  }
}
